import { Component, Input, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DateTime } from 'luxon';
import { SuccessPopupComponent } from '../../../../core/libraries/popup/components/success-popup/success-popup.component';
import { IReportedPostModel } from '../../../../core/models/post.model';
import { GroupsService } from '../../../../core/services/api/groups/groups.service';
import { GroupContextService } from '../../../../core/services/helper/group-context/group-context.service';
import { LoaderService } from '../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-group-management',
    standalone: false,
    templateUrl: './group-management.component.html',
    styleUrl: './group-management.component.scss',
})
export class GroupManagementComponent {
    protected groupManagementSignal = signal<IReportedPostModel>({} as IReportedPostModel);

    constructor(
        private dialog: MatDialog,
        private groupsService: GroupsService,
        private loaderService: LoaderService,
        private groupContextService: GroupContextService,
    ) {}

    @Input() set groupManagementData(value: IReportedPostModel) {
        this.groupManagementSignal.set(value);
    }

    protected removeReportedMember(groupId: number, userId: number): void {
        this.loaderService.show();
        this.groupsService.removeMember(groupId, userId).subscribe({
            next: () => {
                this.groupManagementSignal.update((g) => ({
                    ...g,
                }));
                const popupConfig = SuccessPopupComponent.getDialogConfig();
                popupConfig.data = {
                    title: 'Member Removed',
                    message: 'This member has been removed from the group.',
                    iconPath: '/assets/images/shared/success-green-icon.svg',
                };
                const dialogRef = this.dialog.open(SuccessPopupComponent, popupConfig);
                dialogRef.afterClosed().subscribe(() => {
                    this.groupContextService.notifyGroupReportsUpdated();
                });
            },
            error: (error) => {
                const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                errorPopupConfig.data = {
                    title: `Error`,
                    message: error.error?.message,
                };
                this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                console.error('Error removing reported member:', error);
            },
            complete: () => this.loaderService.hide(),
        });
    }

    protected timeAgo(time: string): string | null {
        return DateTime.fromISO(time).toRelative();
    }
}
